module.exports = {"name":"freewheel","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2018-03-07","repo":"https://bitbucket.org/npaw/freewheel-adapter-js","libVersion":"6.1.13","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getTitle","getResource","getPosition"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 27
// module chunks = 0